import { Col, Row, Skeleton } from 'ui';

const QuickViewCardSkeleton = () => (
  <Row className="quick-view-card-skeleton" gutter="lg">
    <Col>
      <Skeleton.Avatar active shape="circle" size={80} />
    </Col>

    <Col flex="auto">
      <Skeleton active paragraph={{ rows: 2 }} title={false} />
    </Col>
  </Row>
);

export default QuickViewCardSkeleton;
